<template>
    <header class="flex justify-center w-full mb-8">
        <router-link 
            v-for="(item, i) in category"
            :key="i"
            :to="getZisLink(item)" class="flex flex-col mx-1 md:mx-4 lg:mx-3"
        >
            <div class="mb-2">
                <img v-if="item.file === null" :src="getZisIcon(item)" alt="" class="w-full md:w-32" />
                <img v-else v-lazy="item.file_url" alt="" class="w-full md:w-32" />	
            </div>
            <strong class="block text-center">{{item.name}}</strong>
        </router-link>
    </header>
</template>
<script>
import QurbanIcon from '@/../public/assets/images/donation/qurban.svg';
import InfaqIcon from '@/../public/assets/images/donation/infaq.svg';
import ZakatIcon from '@/../public/assets/images/donation/zakat.svg';

export default {
    props: {
        category: {
            type: Array,
            required: true
        }
    },
    methods: {
        getZisIcon(item) {
            if(item.name.toLowerCase() == 'infaq') {
                return InfaqIcon;
            }
            else if(item.name.toLowerCase() == 'qurban') {
                return QurbanIcon;
            }
            
            return ZakatIcon;
        }
    }
}
</script>